import { render, staticRenderFns } from "./Iottery.vue?vue&type=template&id=6c30d6c0&scoped=true"
import script from "./Iottery.vue?vue&type=script&lang=js"
export * from "./Iottery.vue?vue&type=script&lang=js"
import style0 from "./Iottery.vue?vue&type=style&index=0&id=6c30d6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30d6c0",
  null
  
)

export default component.exports